import React, { useState, useEffect } from 'react';
import { LayoutGrid, FileText, Edit3, Image as ImageIcon, BarChart2, MonitorPlay } from 'lucide-react';
import { CATEGORIES, CONVERSIONS } from '../data';

const categoryIcons = {
  'All': LayoutGrid,
  'Documents': FileText,
  'PDF Editor': Edit3,
  'Images': ImageIcon,
  'Data': BarChart2,
  'Presentations': MonitorPlay
};

const styles = {
  section: {
    marginBottom: '48px',
    animation: 'fadeUp 0.5s 0.1s ease both',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

export default function ConversionGrid({ selected, onSelect }) {
  const [activeTab, setActiveTab] = useState(() => {
    const saved = localStorage.getItem('convertalldocs-tab');
    if (CATEGORIES.includes(saved)) {
      return saved;
    }
    const hash = decodeURIComponent(window.location.hash.replace('#', ''));
    return CATEGORIES.includes(hash) ? hash : 'All';
  });
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    localStorage.setItem('convertalldocs-tab', activeTab);
    
    if (activeTab === 'All') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    } else {
      window.history.replaceState(null, '', `#${encodeURIComponent(activeTab)}`);
    }
  }, [activeTab]);

  const visible = activeTab === 'All'
    ? CONVERSIONS
    : CONVERSIONS.filter(c => c.category === activeTab);

  // Helper to assign neon colors
  const getColorClass = (index) => {
    const classes = ['color-pink', 'color-orange', 'color-blue', 'color-purple'];
    return classes[index % classes.length];
  };

  return (
    <div style={styles.section}>
      <div className="tabs-container">
        {CATEGORIES.map((cat) => {
          const Icon = categoryIcons[cat] || LayoutGrid;
          const isActive = activeTab === cat;
          return (
            <button
              key={cat}
              className={`tab-btn ${isActive ? 'active' : ''}`}
              onClick={() => setActiveTab(cat)}
            >
              <Icon size={18} strokeWidth={isActive ? 2.5 : 2} />
              {cat === 'All' ? 'All Tools' : cat}
            </button>
          );
        })}
      </div>

      <div className="conversion-grid">
        {visible.map((conv, index) => {
          const isSelected = selected?.id === conv.id;
          const colorClass = getColorClass(index);
          
          return (
            <div
              key={conv.id}
              className={`conversion-card ${isSelected ? 'selected' : ''} ${colorClass}`}
              onClick={() => onSelect(conv)}
            >
              <div className="card-top-row">
                <div className="badges-container">
                  <span className="badge-text from">{conv.from}</span>
                  <span className="badge-text to">{conv.to}</span>
                </div>
              </div>
              
              <div className="card-name">{conv.label}</div>
              <div className="card-desc">{conv.desc}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
